import React from 'react';
import {withRouter} from "../../../../utils/services/with-router";
import {connect} from "react-redux";
import {Flex, Tabs, TabsProps} from "antd";
import {ApprovedRequestList, Header, OrdersList, RequestList} from "../../components";

const Cartable = () => {
    const onChange = (key: string) => {
    };
    const items: TabsProps['items'] = [
        {
            key: '1',
            label: 'درخواست ها',
            children: <RequestList/>,
        },
        {
            key: '2',
            label: 'تایید شده',
            children: <ApprovedRequestList/>,
        },
        {
            key: '3',
            label: 'سفارشات باز',
            children: <OrdersList/>,
        },
    ];

    return (
        <Flex vertical justify={"center"}>
            <Header/>
            <Tabs centered defaultActiveKey="1" items={items} onChange={onChange} />
        </Flex>
    );
};


export default connect(null, {})(
    withRouter(Cartable)
);
